/* MY ACCOUNT DRAWER - Sign In / Create Account / Forgot Password, and the shopper's account once signed in,
   on every page.
   Markup: snippets/tt-account-drawer.liquid (rendered once, by layout/theme.liquid). Signed in, it holds only
   the account view (snippets/tt-account-summary.liquid, the same view as the desktop header panel).
   Styles: the TT DRAWER SYSTEM in tt-filter.css. Yotpo lookup, reward rules and the summary's points:
   window.ttMember (tt-drawer.js).
   Opens from any link with data-tt-account="signin", "create" or "account": the product page's Rewards row
   and the phone menu's account row (on phones it opens inside the menu, with MENU to go back).
   See the snippet's notes for how sign-in works. */
(function () {
  var drawer = document.getElementById('tt-account-drawer');
  if (!drawer || window.ttAccountDrawer) return;
  var member = window.ttMember; // shared Yotpo lookup and reward rules (tt-drawer.js)

  var KLAVIYO_COMPANY = 'HfvVqt';
  var KLAVIYO_LIST = 'LpFayj'; // Newsletter (single opt-in)
  // Where the account was made, for Klaviyo: set each time the drawer opens.
  var ACCOUNT_SOURCE = 'Product Page Drawer';
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var BUTTON = { signin: 'Sign In', create: 'Create Account', recover: 'Send Reset Link', done: 'Continue Shopping' };
  var FORM = { signin: 'customer_login', create: 'tt-acct-create-form', recover: 'tt-acct-recover-form' };

  var tabs = drawer.querySelector('[data-tt-acct-tabs]');
  var body = drawer.querySelector('.tt-acct__body');
  var submit = drawer.querySelector('[data-tt-acct-submit]');
  var footer = drawer.querySelector('.tt-acct__footer');
  var fine = drawer.querySelector('.tt-acct__fine');
  var signout = drawer.querySelector('[data-tt-acct-signout]');
  var summaryBox = drawer.querySelector('[data-tt-acct-summary]');
  // Signed-in pages have no forms or tabs: the drawer is the account view only.
  var current = tabs ? 'signin' : 'done';
  var lastFocus = null;

  function $(sel, root) { return (root || drawer).querySelector(sel); }

  // The button while the drawer works: "Signing In •••". Words stay, three dots pulse.
  var WORKING = { signin: 'Signing In', create: 'Creating Your Account', recover: 'Sending' };
  function busy(on) {
    submit.disabled = on;
    drawer.classList.toggle('is-busy', on);
    if (on && WORKING[current]) {
      submit.textContent = WORKING[current];
      var dots = document.createElement('span');
      dots.className = 'tt-acct__dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = '<span></span><span></span><span></span>';
      submit.appendChild(dots);
      submit.setAttribute('aria-busy', 'true');
    } else {
      submit.textContent = BUTTON[current];
      submit.removeAttribute('aria-busy');
    }
  }

  function show(view) {
    current = view;
    drawer.querySelectorAll('[data-tt-acct-view]').forEach(function (el) {
      el.hidden = el.getAttribute('data-tt-acct-view') !== view;
    });
    drawer.querySelectorAll('.tt-acct__tab').forEach(function (el) {
      el.setAttribute('aria-selected', el.getAttribute('data-tt-acct-tab') === view ? 'true' : 'false');
    });
    if (tabs) tabs.hidden = view === 'recover' || view === 'done';
    drawer.querySelectorAll('.tt-acct__legal, .tt-acct__fine').forEach(function (el) { el.hidden = view === 'done'; });
    if (signout) signout.hidden = view !== 'done';
    busy(false);
    body.scrollTop = 0;
    drawer.querySelectorAll('[data-tt-acct-error]').forEach(function (el) { el.textContent = ''; });
    pin();
  }

  // The line above the button shows only while the button is pinned over form still scrolling under it.
  function pin() {
    var after = fine && !fine.hidden ? fine.offsetHeight : 0;
    var below = body.scrollHeight - body.scrollTop - body.clientHeight;
    footer.classList.toggle('is-pinned', below > after + 1);
  }

  // Loads ES modules through a small module script. (Shopify minifies theme asset files when it serves them
  // and turns a dynamic import into require, which does not exist in the browser.) Resolves with what the
  // module hands back; rejects if it fails to load.
  function loadModule(code) {
    return new Promise(function (resolve, reject) {
      var done = 'ttModule' + Date.now() + Math.random().toString(36).slice(2);
      var script = document.createElement('script');
      window[done] = function (value) { delete window[done]; script.remove(); resolve(value); };
      script.type = 'module';
      script.textContent = code.replace('DONE', 'window.' + done);
      script.onerror = function () { delete window[done]; script.remove(); reject(new Error('module did not load')); };
      document.head.appendChild(script);
    });
  }

  // Sign in with Shop: the same two scripts and calls Shopify runs on /account/login. They look for
  // the form named customer_login and watch its email field. Loaded once, the first time the drawer opens.
  var shopReady = null;
  function shopSignIn() {
    if (!document.getElementById(FORM.signin)) return Promise.resolve();
    if (!shopReady) {
      var base = 'https://cdn.shopify.com/shopifycloud/shop-js/modules/v2/loader.';
      var opts = { fedCMEnabled: true, windoidEnabled: true };
      var form = document.getElementById(FORM.signin);
      if (form) form.setAttribute('data-login-with-shop-sign-in', 'true');
      shopReady = !(window.Shopify && window.Shopify.SignInWithShop) ? Promise.resolve() : loadModule(
        'import "' + base + 'init-customer-accounts.en.esm.js"; import "' + base + 'init-customer-accounts-sign-up.en.esm.js"; DONE();'
      ).then(function () {
        var shop = window.Shopify.SignInWithShop;
        if (shop.initCustomerAccounts) shop.initCustomerAccounts(true, opts);
        if (shop.initCustomerAccountsSignUp) shop.initCustomerAccountsSignUp(opts);
      }).catch(function (error) {
        console.warn('[account drawer] Sign in with Shop did not load', error);
      });
    }
    return within(shopReady, 2500);
  }

  // Phone menu: opened from the menu's Sign In row, the drawer slides in from the menu's side at the menu's
  // width, over the menu (one level deeper, like Dresses). MENU slides it away and leaves the menu open;
  // so does Continue Shopping after signing in. X, tapping outside and Escape close both. Anywhere else it
  // is the usual drawer/sheet.
  var menu = document.getElementById('sidebar-menu');
  var phone = window.matchMedia('(max-width: 699px)');
  var fromMenu = false;
  var settleTimer = null;
  var trap = null;

  // The menu closes on any tap outside its own panel, and keeps keyboard focus inside itself. While this
  // drawer sits over it, take over with the theme's own focus trap (the same one the menu uses): the menu's
  // trap pauses, so taps and typing in here leave the menu alone, and it resumes when this slides away.
  function holdMenu() {
    loadModule('import { FocusTrap } from "vendor"; DONE(FocusTrap);').then(function (FocusTrap) {
      if (!fromMenu || !drawer.classList.contains('is-open') || trap) return;
      trap = FocusTrap.createFocusTrap(drawer, {
        initialFocus: false,
        fallbackFocus: drawer.querySelector('.tt-drw__panel'),
        escapeDeactivates: false,
        clickOutsideDeactivates: false,
        allowOutsideClick: true,
        returnFocusOnDeactivate: false,
        tabbableOptions: { getShadowRoot: true }
      });
      trap.activate();
    }).catch(function (error) {
      console.warn('[account drawer] could not hold the menu open', error);
    });
  }

  function releaseMenu() {
    if (trap) { trap.deactivate(); trap = null; }
  }

  function menuOpen() {
    return !!(menu && menu.open && typeof menu.hide === 'function');
  }

  function open(view, viaMenu) {
    clearTimeout(settleTimer);
    fromMenu = !!viaMenu && phone.matches && menuOpen();
    if (!fromMenu && menuOpen()) menu.hide();
    // Set the starting edge (side or bottom) with no animation, then slide in from there.
    var own = drawer.querySelector('.tt-drw__panel');
    own.style.transition = 'none';
    drawer.classList.toggle('tt-drw--from-menu', fromMenu);
    if (fromMenu) {
      var panel = menu.shadowRoot && menu.shadowRoot.querySelector('[part~="content"]');
      if (panel) drawer.style.setProperty('--tt-menu-w', panel.getBoundingClientRect().width + 'px');
      drawer.classList.toggle('tt-drw--left', menu.getAttribute('open-from') === 'left');
    }
    void own.offsetHeight;
    own.style.transition = '';
    lastFocus = document.activeElement;
    var here = window.location.pathname + window.location.search;
    drawer.querySelectorAll('[data-tt-acct-return]').forEach(function (el) { el.value = here; });
    show(view);
    if (view === 'done') member.summary(summaryBox);
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('tt-drw-open');
    requestAnimationFrame(pin);
    if (fromMenu) holdMenu();
    // Focus the first field once the drawer has slid in and Shop is listening for it.
    Promise.all([shopSignIn(), new Promise(function (resolve) { setTimeout(resolve, 340); })]).then(function () {
      if (current !== view) return;
      var first = $('[data-tt-acct-view="' + view + '"] input:not([type="hidden"]):not([type="checkbox"])');
      if (first && window.matchMedia('(min-width: 700px)').matches) first.focus();
    });
  }

  // back: from the menu, slide away and leave the menu open (MENU, and Continue Shopping after signing in).
  // Otherwise (X, outside, Escape) close the drawer, and the menu too if it was opened from there.
  function close(back) {
    var wasMenu = fromMenu;
    releaseMenu();
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('tt-drw-open');
    if (wasMenu && !back && menuOpen()) menu.hide();
    if (lastFocus && lastFocus.focus && (back || !wasMenu)) lastFocus.focus();
    // Once it has slid away, it goes back to being the usual drawer/sheet.
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      if (drawer.classList.contains('is-open')) return;
      fromMenu = false;
      drawer.classList.remove('tt-drw--from-menu', 'tt-drw--left');
    }, 360);
  }

  function setError(view, message) {
    var el = $('[data-tt-acct-view="' + view + '"] [data-tt-acct-error]');
    if (el) el.textContent = message;
    busy(false);
    pin();
  }

  function signedIn() {
    return fetch('/account', { credentials: 'same-origin' })
      .then(function (res) { return !/\/account\/login/.test(res.url); })
      .catch(function () { return false; });
  }

  // Same rules as the Back in Stock pop-up: E.164, '' if empty, null if invalid.
  function normalizePhone(countryCode, value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (!digits) return '';
    if (countryCode === '+1') {
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? countryCode + digits : null;
    }
    digits = digits.replace(/^0+/, '');
    return digits.length >= 7 && digits.length <= 12 ? countryCode + digits : null;
  }

  // Every new account, whatever boxes were ticked: a "Created Account" event and a profile property
  // saying where the account was made. Not a marketing signup; it only labels the profile.
  function klaviyoAccountCreated(email, phone, first, last, wantsEmail) {
    var profile = {
      email: email,
      first_name: first,
      last_name: last,
      properties: { 'Account Created From': ACCOUNT_SOURCE }
    };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: { Source: ACCOUNT_SOURCE, Page: window.location.pathname, 'Email Opt In': !!wantsEmail, 'SMS Opt In': !!phone },
            metric: { data: { type: 'metric', attributes: { name: 'Created Account' } } },
            profile: { data: { type: 'profile', attributes: profile } }
          }
        }
      })
    }).catch(function (error) {
      console.warn('[account drawer] Klaviyo account event failed', error);
    });
  }

  // Email and SMS consent to Klaviyo's main Newsletter list.
  function klaviyoSubscribe(email, phone, wantsEmail, first, last) {
    if (!wantsEmail && !phone) return Promise.resolve();
    var attributes = { email: email, first_name: first, last_name: last, subscriptions: {} };
    if (phone) attributes.phone_number = phone;
    if (wantsEmail) attributes.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
    if (phone) {
      attributes.subscriptions.sms = {
        marketing: { consent: 'SUBSCRIBED' },
        transactional: { consent: 'SUBSCRIBED' }
      };
    }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: attributes } },
            custom_source: 'Create Account'
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      })
    }).catch(function (error) {
      console.warn('[account drawer] Klaviyo subscription failed', error);
    });
  }

  // ---- The account view after signing in ----
  var tierFrom = member.tierFrom;
  var memberDetails = member.details;
  // Trina Turk Rewards is US only for now (tt-drawer.js): elsewhere sign-in does not wait on Yotpo.
  var rewardsOn = member.rewards !== false;

  function within(promise, ms) {
    return Promise.race([promise, new Promise(function (resolve) { setTimeout(function () { resolve(null); }, ms); })]);
  }

  // Lets the Rewards row show the same balance the moment the page refreshes.
  function remember(id, points) {
    try { if (id && typeof points === 'number') sessionStorage.setItem('tt_rewards_' + id, String(points)); } catch (e) {}
  }

  // The shopper's account, drawn by Shopify now they are signed in: the header section holds the header
  // account panel, which renders snippets/tt-account-summary.liquid. Fetch it once (no reload), put the
  // summary in this drawer, and give the header panel its signed-in version too. Resolves with the first
  // name and tier it shows, or null if it could not be drawn.
  function freshAccount() {
    var item = document.querySelector('.header__account-link');
    var sec = item && item.closest('[id^="shopify-section-"]');
    if (!sec) return Promise.resolve(null);
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sec.id.replace('shopify-section-', ''));
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tt-ap]');
        if (!fresh || !fresh.querySelector('[data-tt-ap-points]')) return null;
        summaryBox.innerHTML = fresh.innerHTML;
        var panel = item.querySelector('[data-tt-ap]');
        if (panel) panel.innerHTML = fresh.innerHTML;
        var h = fresh.querySelector('.tt-ap__h');
        var t = fresh.querySelector('.tt-ap__head .tt-ap__s');
        var name = /^Welcome Back,\s*(.+)$/i.exec(h ? h.textContent.trim() : '');
        var tier = /^(.+) Member$/i.exec(t ? t.textContent.trim() : '');
        return { first: name ? name[1] : '', tier: tier ? tier[1] : '' };
      })
      .catch(function () { return null; });
  }

  // Open the account view. With the account drawn: the summary, its points from the balance in hand (or
  // asked for, when ask is set), and the header panel switched back on with its signed-in version. Without
  // it (the section could not be fetched): a plain Welcome line, and the account page is a tap away.
  function ready(acct, title, points, ask) {
    summaryBox.hidden = !acct;
    $('[data-tt-acct-fallback]').hidden = !!acct;
    $('[data-tt-acct-welcome]').textContent = title;
    if (acct) {
      var item = document.querySelector('.header__account-link');
      if (item) item.removeAttribute('data-tt-ap-off');
      if (typeof points === 'number' || ask) member.summary(summaryBox, points);
    }
    show('done');
    setTimeout(function () { if (window.matchMedia('(min-width: 700px)').matches) submit.focus(); }, 50);
  }

  // ---- Sending the forms ----
  // Shopify's spam check takes over these forms and sends them itself, so they are sent into a
  // hidden frame on this page instead of loading a new page. When the frame finishes, check the result.
  var frame = drawer.querySelector('iframe[name="tt-acct-frame"]');
  var pending = null;
  var pendingTimer = null;
  [FORM.signin, FORM.create, FORM.recover].forEach(function (id) {
    var form = document.getElementById(id);
    if (form) form.setAttribute('target', 'tt-acct-frame');
  });

  // Checks the fields before anything is sent. Returns what the result step needs, or null.
  function check(form) {
    if (form.id === FORM.signin) {
      if (form.querySelector('input[name="login_with_shop"]')) return { view: 'signin' };
      var email = form.elements['customer[email]'].value.trim();
      if (!EMAIL_PATTERN.test(email)) return setError('signin', 'Please enter a valid email.'), null;
      if (!form.elements['customer[password]'].value) return setError('signin', 'Please enter your password.'), null;
      return { view: 'signin' };
    }
    if (form.id === FORM.create) {
      var first = form.elements['customer[first_name]'].value.trim();
      var last = form.elements['customer[last_name]'].value.trim();
      var cEmail = form.elements['customer[email]'].value.trim();
      var phone = normalizePhone($('[data-tt-acct-country]').value, $('[data-tt-acct-phone]').value);
      if (!first || !last) return setError('create', 'Please enter your first and last name.'), null;
      if (!EMAIL_PATTERN.test(cEmail)) return setError('create', 'Please enter a valid email.'), null;
      if (form.elements['customer[password]'].value.length < 5) return setError('create', 'Your password needs at least 5 characters.'), null;
      if (phone === null) return setError('create', 'Please enter a valid phone number, or leave it blank.'), null;
      return {
        view: 'create', first: first, last: last, email: cEmail, phone: phone,
        wantsEmail: form.elements['customer[accepts_marketing]'].checked
      };
    }
    if (form.id === FORM.recover) {
      if (!EMAIL_PATTERN.test(form.elements.email.value.trim())) return setError('recover', 'Please enter a valid email.'), null;
      return { view: 'recover' };
    }
    return null;
  }

  // Put the signed-in Rewards row on the page behind the welcome, from the freshly drawn section,
  // and run its script (it fetches the balance and keeps the row up to date on size/color changes).
  // Only that one block changes; nothing else on the page moves.
  function swapRewards(doc) {
    try {
      var fresh = doc.querySelector('.tt-rewards');
      var cur = document.querySelector('.tt-rewards');
      if (!fresh || !cur) return;
      var freshItem = fresh.closest('.product-info__block-item') || fresh.parentElement;
      var curItem = cur.closest('.product-info__block-item') || cur.parentElement;
      curItem.innerHTML = freshItem.innerHTML;
      curItem.querySelectorAll('script').forEach(function (old) {
        var run = document.createElement('script');
        run.textContent = old.textContent;
        old.parentNode.replaceChild(run, old);
      });
    } catch (e) {
      console.warn('[account drawer] could not update the Rewards row', e);
    }
  }

  // Name and tier from Shopify itself: re-draw this page's product section now that the shopper is
  // signed in (the Rewards row in it prints first name and tier), so they never depend on the rewards
  // service answering in time. The same drawing also replaces the Rewards row behind the drawer.
  function pageMember() {
    var row = document.querySelector('.tt-rewards');
    var sec = row && row.closest('[id^="shopify-section-"]');
    if (!sec) return Promise.resolve(null);
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sec.id.replace('shopify-section-', ''));
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.tt-rewards');
        if (!fresh) return null;
        swapRewards(doc);
        var h = fresh.querySelector('.tt-trust-badge__heading');
        var m = /^Welcome Back,\s*(.+)$/i.exec(h ? h.textContent.trim() : '');
        var info = fresh.querySelector('[data-tt-tier]');
        return {
          first: m && !/^Rewards Member$/i.test(m[1]) ? m[1].trim() : '',
          tier: info ? info.getAttribute('data-tt-tier') || '' : '',
          isNew: !!(info && info.hasAttribute('data-tt-new-member'))
        };
      })
      .catch(function () { return null; });
  }

  function signedInWelcome() {
    // The account (name, tier, latest order, links) comes from Shopify (freshAccount, about a third of a
    // second). Points come from Yotpo: asked straight away and again every 0.7s if the answer comes back
    // empty, for up to 5 seconds, while the button reads "Signing In". The account opens as soon as both
    // are in (usually about a second). Points are never assumed: if Yotpo has not answered in 5 seconds the
    // account opens without them and they fill in when Yotpo answers.
    var started = Date.now();
    function ask() {
      return memberDetails().then(function (m) {
        if (m && typeof m.points === 'number') return m;
        var left = 5000 - (Date.now() - started);
        if (left <= 0) return m;
        return new Promise(function (resolve) { setTimeout(resolve, Math.min(700, left)); }).then(ask);
      });
    }
    return Promise.all([rewardsOn ? within(ask(), 5000) : null, within(freshAccount(), 5000), within(pageMember(), 5000)]).then(function (r) {
      var m = r[0];
      var acct = r[1];
      var known = r[2] || {};
      var first = (m && m.first) || (acct && acct.first) || known.first || '';
      var tier = (m && tierFrom(m.tags, false)) || (acct && acct.tier) || known.tier || '';
      var points = m && typeof m.points === 'number' ? m.points : null;
      if (points !== null) remember(m.id, points);
      else if (rewardsOn) console.warn('[account drawer] rewards balance not in within 5s of sign-in');
      member.signedIn({ first: first, tier: tier, points: points });
      // No balance yet: the points stay out of the summary rather than show a guess; the summary asks again.
      ready(acct, first ? 'Welcome Back, ' + first : 'Welcome Back', points, points === null);
    });
  }

  function createdWelcome(p) {
    klaviyoSubscribe(p.email, p.phone, p.wantsEmail, p.first, p.last);
    klaviyoAccountCreated(p.email, p.phone, p.first, p.last, p.wantsEmail);
    pageMember();
    return within(freshAccount(), 5000).then(function (acct) {
      var tier = (acct && acct.tier) || (rewardsOn ? 'Bronze' : '');
      member.signedIn({ first: p.first, tier: tier, points: null });
      ready(acct, 'Welcome, ' + p.first, null, false);
      if (!rewardsOn) return;
      // Yotpo adds the sign-up points a few seconds after the account is made (it reads 0 until then), so
      // the points show once the real balance is in: asked every 1.5 seconds, up to 5 times.
      var tries = 5;
      (function again() {
        memberDetails().then(function (m) {
          if (current !== 'done') return;
          if (m && typeof m.points === 'number' && m.points > 0) {
            remember(m.id, m.points);
            if (acct) member.summary(summaryBox, m.points);
            member.signedIn({ first: p.first, tier: tierFrom(m.tags, true) || tier, points: m.points });
            return;
          }
          if (--tries > 0) setTimeout(again, 1500);
        });
      })();
    });
  }

  if (frame) {
    frame.addEventListener('load', function () {
      if (!pending) return;
      var p = pending;
      pending = null;
      clearTimeout(pendingTimer);
      if (p.view === 'recover') {
        $('[data-tt-acct-recover-sent]').hidden = false;
        busy(false);
        submit.disabled = true;
        return;
      }
      signedIn().then(function (ok) {
        if (p.view === 'signin') {
          if (ok) return signedInWelcome();
          setError('signin', 'Incorrect email or password.');
        } else if (p.view === 'create') {
          if (ok) return createdWelcome(p);
          setError('create', 'We couldn\'t create your account. If you already have one, use Sign In.');
        }
      });
    });
  }

  // Sign in with Shop finishes in Shop's own window, which tells this page it is done. Shop's script then
  // sends the whole page to /account/redirect: a full reload that closes the phone menu and lands on the
  // home page. Stay put instead, as email sign-in does: take that message before Shop's script sees it,
  // close Shop's window, check the shopper really is signed in, and show the same welcome. If Shop still
  // has a step to finish, or the shopper is not signed in, let Shop carry on exactly as before.
  window.addEventListener('message', function (event) {
    if ((event.origin !== window.location.origin && event.origin !== 'https://shop.app') || !drawer.classList.contains('is-open')) return;
    var data = event.data;
    if (typeof data === 'string') { try { data = JSON.parse(data); } catch (e) { return; } }
    if (!data || data.type !== 'completed' || !data.loggedIn || data.shouldFinalizeLogin) return;
    event.stopImmediatePropagation();
    try { if (event.source && event.source !== window) event.source.close(); } catch (e) {}
    show('signin');
    busy(true);
    signedIn().then(function (ok) {
      if (ok) return signedInWelcome();
      window.location.href = data.returnUri || '/account';
    });
  }, true);

  // Runs before Shopify's spam check: stop a form with a mistake, otherwise let it go on its way.
  drawer.addEventListener('submit', function (event) {
    var form = event.target;
    var p = check(form);
    if (!p) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    pending = p;
    busy(true);
    drawer.querySelectorAll('[data-tt-acct-error]').forEach(function (el) { el.textContent = ''; });
    // If nothing comes back (for example the shopper closes the spam check's puzzle), free the button.
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { busy(false); }, 30000);
  }, true);

  drawer.addEventListener('click', function (event) {
    if (event.target.closest('[data-tt-acct-menu-back]')) { close(true); return; }
    if (event.target.closest('[data-tt-acct-close]')) { close(); return; }
    var tab = event.target.closest('[data-tt-acct-tab]');
    if (tab) { show(tab.getAttribute('data-tt-acct-tab')); return; }
    if (event.target.closest('[data-tt-acct-submit]')) {
      // Continue Shopping: opened from the phone menu, slide back to the menu (now showing their account).
      if (current === 'done') { close(fromMenu); return; }
      var form = drawer.querySelector('#' + FORM[current]);
      if (form) {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          // Older browsers: check the fields, then send straight into the hidden frame.
          var p = check(form);
          if (p) { pending = p; busy(true); form.submit(); }
        }
      }
    }
  });

  body.addEventListener('scroll', pin, { passive: true });
  window.addEventListener('resize', pin);
  drawer.addEventListener('input', pin);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // Take over the Sign In / Create Account links (they still work as plain links if this fails to load).
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-tt-account]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    var viaMenu = link.hasAttribute('data-tt-menu-acct');
    ACCOUNT_SOURCE = viaMenu ? 'Mobile Menu Drawer' : link.closest('.header') ? 'Header' : 'Product Page Drawer';
    var kind = link.getAttribute('data-tt-account');
    open(kind === 'create' ? 'create' : kind === 'account' ? 'done' : 'signin', viaMenu);
  });

  // Header (Oct 26, Chris): signed out, the account icon and the hover panel's Sign In / Create Account buttons
  // open this drawer on Sign In / Create Account instead of the old account pages. Nov 1 (Chris): signed in, the
  // icon opens this drawer on their account too (the same view as the hover), never the old account pages; so
  // does the icon after signing in on this page. Done here, not in header.liquid, so the header file stays
  // untouched. New accounts: "Account Created From" = Header.
  document.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.defaultPrevented) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-tt-account') || !link.closest('.header, height-observer, x-header, #shopify-section-header, [id$="__header"]')) return;
    if (link.closest('#sidebar-menu, .header-sidebar')) return; // the phone menu has its own row
    if (link.closest('[data-tt-ap]')) return; // links inside the hover panel go where they say
    var path;
    try { path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/$/, ''); } catch (e) { return; }
    var view = path === '/account/login' || path === '/account' ? 'signin' : path === '/account/register' ? 'create' : '';
    if (!view) return;
    if (current === 'done') view = 'done';
    else if (!tabs) return;
    event.preventDefault();
    if (window.ttAccountPanel) window.ttAccountPanel.hide();
    ACCOUNT_SOURCE = 'Header';
    open(view, false);
  });

  // Other scripts (tt-wishlist-signin.js) name where the drawer was opened from, for "Account Created From".
  function source(name) { if (name) ACCOUNT_SOURCE = name; }

  window.ttAccountDrawer = { el: drawer, open: open, close: close, source: source };
})();
